import React from 'react';
import { NavLink } from 'react-router-dom';
import Button from '../button/button';

import { APP_CONFIG } from '../../app-constants';

const CallToAction = ({
  buttonText,
  buttonId,
  customClasses,
  route,
  hasBorderTop,
  hasPaddingBox = true,
  alignment = 'right',
  isExactUrl = false,
}) => (
  <div className="row cta">
    <div className={`col text-center text-sm-${alignment} border-mob-none border-bottom cta-button-wrapper
      ${hasBorderTop ? 'border-top' : ''}
      ${hasPaddingBox ? 'padding-box' : ''}`}
    >
      <NavLink
        exact={isExactUrl}
        to={`${APP_CONFIG.reactBasePath + route}`}
      >
        <Button
          id={buttonId}
          className={`button ${customClasses}`}
          buttonText={buttonText}
        />
      </NavLink>
    </div>
  </div>
);

export default CallToAction;
